export default "__VITE_ASSET___l2RYSrp__"